/* eslint-disable no-unused-vars */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/no-unstable-nested-components */
import { ExportCsv } from '@material-table/exporters';
// import { TablePagination } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import DownloadIcon from '@mui/icons-material/Download';
import MaterialTable from 'material-table';
import { colors } from '../../utils';
import { Slide, TablePagination } from '@mui/material';

const { colorLight, colorPrimary, colorWhite, colorTextDark } = colors;

// function PatchedPagination(props) {
// 	const { ActionsComponent, onPageChange, onRowsPerPageChange, ...tablePaginationProps } = props;

// 	return (
// 		<TablePagination
// 			{...tablePaginationProps}
// 			// Note: onChangePage has been renamed to onPageChange in MUI v5
// 			onPageChange={onPageChange}
// 			onRowsPerPageChange={onRowsPerPageChange}
// 			ActionsComponent={(subprops) => {
// 				const { onPageChange, ...actionsComponentProps } = subprops;
// 				return (
// 					// Note: ActionsComponent is a custom component; ensure it's compatible with MUI v5
// 					<ActionsComponent {...actionsComponentProps} onChangePage={onPageChange} />
// 				);
// 			}}
// 		/>
// 	);
// }

function Table({
	columns,
	tableData,
	setTableData,
	detailPanel,
	editable,
	sorting,
	search,
	searchFieldAlignment,
	searchAutoFocus,
	searchText,
	showTitle,
	titleHeading,
	filtering,
	paging,
	pageSize,
	pageSizeOptions_,
	showFirstLastPageButtons,
	exportButton,
	exportAllData,
	exportFileName,
	searchFieldStyle,
	selection,
	showSelectAllCheckbox,
	headerStyle,
	rowStyle,
	columnsButton,
	debounceInterval,
	padding,
	paginationType,
	tableRef,
	headerPadding,
	onChangeRowsPerPage,
	headerStyleAlign,
	bulkDeleteTableAction,
	addListAction,
	assignShift,
	showToolbar,
	exportData,
	onClickRow,
	totalRecords,
	handlePageChange,
	curPage,
	hidePagination
}) {
	const theme = createTheme({
		overrides: {
			MuiTooltip: {
				tooltip: {
					fontSize: '1em',
				},
			},
		},
		palette: {
			primary: {
				main: '#333',
			},
			secondary: {
				main: '#000',
			},
		},
	});

	const pageSizeOptions = [];

	if (tableData?.length > 4) {
		pageSizeOptions.push(5);
	}
	if (tableData?.length > 9) {
		pageSizeOptions.push(10);
	}
	if (tableData?.length > 20) {
		pageSizeOptions.push(20);
	}
	if (tableData?.length > 50) {
		pageSizeOptions.push(50);
	}
	if (tableData?.length > 100) {
		pageSizeOptions.push(50);
	}

	// const downloadExcel = () => {
	// 	const newData = tableData.map((row) => {
	// 		delete row.tableData;
	// 		return row;
	// 	});
	// 	const workSheet = XLSX.utils.json_to_sheet(newData);
	// 	const workBook = XLSX.utils.book_new();
	// 	XLSX.utils.book_append_sheet(workBook, workSheet, 'students');
	// 	//Buffer
	// 	let buf = XLSX.write(workBook, { bookType: 'xlsx', type: 'buffer' });
	// 	//Binary string
	// 	XLSX.write(workBook, { bookType: 'xlsx', type: 'binary' });
	// 	//Download
	// 	XLSX.writeFile(workBook, 'StudentsData.xlsx');
	// };

	// options
	const options = {
		sorting: sorting || false,
		search: search || false,
		searchText,
		searchFieldAlignment: searchFieldAlignment || 'right',
		searchAutoFocus: searchAutoFocus || false,
		searchFieldVariant: 'standard',
		filtering: filtering || false,
		paging: paging || true,
		emptyRowsWhenPaging: false,
		paging: true,
		pageSize: pageSize || 10,
		paginationType: paginationType || 'stepped',
		// showFirstLastPageButtons: showFirstLastPageButtons || true,
		// paginationPosition: 'bottom',
		exportButton: exportButton || false,
		exportAllData: exportAllData || false,
		exportFileName: exportFileName || 'Table Data',
		addRowPosition: 'first',
		searchFieldStyle: searchFieldStyle || { fontSize: '1.4rem' },
		actionsColumnIndex: -1,
		selection: selection || false,
		showSelectAllCheckbox: showSelectAllCheckbox || false,
		showTitle: showTitle || false,
		columnsButton: columnsButton || false,
		rowStyle: rowStyle || {
			background: '#fff',
			fontSize: '1.3rem',
		},
		headerStyle: headerStyle || {
			background: colorLight,
			color: colorTextDark,
			fontSize: '1.3rem',
			// padding: headerPadding || '0.8rem',
			textAlign: headerStyleAlign,
			fontWeight: '700',
			fontFamily: 'poppins, sans-serif',
		},
		debounceInterval: debounceInterval && 700,
		// padding: padding && 'dense',
		toolbar: showToolbar,
		tableLayout:"fixes"
	};

	// if (!debounceInterval) {
	// 	options.pageSizeOptions = pageSizeOptions_ || [5, 10, 20, 50, 100];
	// }

	return (
		<MuiThemeProvider theme={theme}>
			<Slide direction="up" in={tableData?.length > 0} mountOnEnter unmountOnExit>

				<div className='table'>
					<MaterialTable
						// components={{
						// 	Pagination: PatchedPagination,
						// }}
						components={{
							Pagination: (props) => (
								!hidePagination ? (
									<TablePagination
										// {...props}
										
										rowsPerPageOptions={[10, 20, 50]}
										page={curPage}
										component="div"
										rowsPerPage={pageSize}
										count={totalRecords}
										onPageChange={handlePageChange}
										onRowsPerPageChange={onChangeRowsPerPage}
										sx={{
											'& .MuiToolbar-root > *': {
												fontSize: '1.8em !important',
											},
											'& .MuiSvgIcon-root': {
												fontSize: '1.2em !important',
											},
											// .css-10by3a5--MuiMenuItem-root-MuiTablePagination-menuItem.Mui-selected
										}}
										SelectProps={{
											MenuProps: {
											  sx: {
												'.MuiTablePagination-menuItem': {
													fontSize: '1.5em !important',
												},
											  },
											},
										  }}
									/>
								) : null
							),
						}}
						style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}
						icons={
							{
								// Filter: () => {
								//   <Tooltip title="Search">
								//     <SearchIcon />
								//   </Tooltip>;
								// }
							}
						}
						title={titleHeading}
						tableRef={tableRef}
						columns={columns}
						data={tableData}
						detailPanel={detailPanel}
						editable={
							editable
								? {
									// onRowAdd: (newRow) =>
									//   // eslint-disable-next-line no-unused-vars
									//   new Promise((resolve, reject) => {
									//     setTableData([...tableData, newRow]);
									//     resolve();
									//   }),
									onRowUpdate: (newRow, oldRow) =>
										new Promise((resolve, reject) => {
											const updateData = [...tableData];
											updateData[oldRow.tableData.id] = newRow;
											// console.log('new row', newRow);

											// doctor Specialization edit
											// if (specEditData) specEditData(newRow);
											// doctor subscription edit
											// if (subsEditData) subsEditData(newRow);
											resolve();
										}),
									onRowDelete: (selectedRow) =>
										new Promise((resolve, reject) => {
											const updateData = [...tableData];
											updateData.splice(selectedRow.tableData.id, 1);

											setTableData(updateData);
											resolve();
										}),
								}
								: null
						}
						actions={[
							// (rowData) => ({
							//   icon: () => <EditIcon />,
							//   // eslint-disable-next-line no-shadow
							//   onClick: (event, rowData) => {
							//     setSpecData(rowData);
							//   }
							// }),
							// {
							// 	icon: () => <button>Export</button>, // you can pass icon too
							// 	tooltip: 'Export to Excel',
							// 	onClick: () => downloadExcel(),
							// 	isFreeAction: true,
							// },
							exportData,
							{
								position: 'toolbarOnSelect',
								icon: () => (
									<div type='button'>
										<DownloadIcon style={{ fontSize: '2rem' }} />
									</div>
								),
								tooltip: 'Export Selected Rows',
								onClick: (e, rowData) => {
									'Export CSV';
									ExportCsv(columns, rowData, `${exportFileName} Selected`);
								},
							},
							bulkDeleteTableAction,
							addListAction,
							assignShift,
							// {
							//   icon: () => (
							//     <div type="button">
							//       <DownloadIcon style={{ fontSize: '2rem' }} />
							//     </div>
							//   ),
							//   tooltip: 'Download',
							//   onClick: (e, data) => {console.log(data)},
							//   isFreeAction: false,
							//   iconProps: { fontSize: 'large', color: 'primary' }
							// }
							// {
							// 	position: 'toolbarOnSelect',
							// 	icon: () => (
							// 		<div type='button'>
							// 			<LocalPrintshopIcon style={{ fontSize: '1.5rem' }} />
							// 		</div>
							// 	),
							// 	tooltip: 'Print',
							// 	onClick: (e, data) => {
							// 		console.log(data);
							// 	},
							// 	isFreeAction: true,
							// 	iconProps: { fontSize: 'large', color: 'primary' },
							// },
						]}
						options={options}
						// onChangeRowsPerPage={onChangeRowsPerPage && onChangeRowsPerPage}
						onRowClick={(event, rowData) => {
							if (typeof onClickRow === 'function') {
								onClickRow(rowData);
							}
						}}
					/>
				</div>
			</Slide>
		</MuiThemeProvider>
	);
}

export default Table;
